import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';

import App from './App';  //根组件

import 'antd/dist/antd.css';  //antd 组件样式
import './style/base.css';  //全局基本样式
import './style/style.css';  //全局样式
import $config from '@/config';
//设置日期组件为中文
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

//start
ReactDOM.render(
    <React.Fragment>
        <ConfigProvider locale={zhCN}>
            <App />
        </ConfigProvider>
    </React.Fragment>,
    document.getElementById('app-root')
);
